import { createContext } from 'react'

import { type BrokersEmployerICHRAConfig } from 'utils/web_api.schemas'

export type BrokersMemberContextType = {
  memberId: string
  planYear?: number
  employerIchraConfig?: BrokersEmployerICHRAConfig
  isTieredAllowancesEmployer?: boolean
  isUserThatchAdmin?: boolean
  isUserThatchWorkflowAdmin?: boolean
  isEmployerApproved?: boolean
  visaImagePath?: string
  stripePublishableKey?: string
}

const BrokersMemberContext = createContext<BrokersMemberContextType>({
  memberId: '',
  planYear: 0,
  employerIchraConfig: undefined,
  isTieredAllowancesEmployer: false,
  isUserThatchAdmin: false,
  isUserThatchWorkflowAdmin: false,
  isEmployerApproved: false,
  visaImagePath: undefined,
  stripePublishableKey: undefined,
})

export default BrokersMemberContext
